import styled from 'styled-components';

import Row from 'react-bootstrap/Row';

export const StyledCardNf = styled(Row)`
  border-bottom: 1px solid #f2f2f2;
  margin: 0 1rem;
  padding: 0.5rem 0rem 1rem 1rem;
`;
